import React, { useState, createContext, useCallback, useContext } from "react";
import axios from "axios";
import Cookies from "js-cookie";

export const AnnouncementsContext = createContext();

axios.defaults.withCredentials = true;

export const AnnouncementsContextProvider = ({ children }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [customAnnouncement, setCustomAnnouncement] = useState({
    announcement_type: "custom",
    announcement_title: "",
    announcement_message: "",
    announcement_groups: [],
    files: [],
    deletedFiles: [],
    addedFiles: [],
  });
  const [annSuccess, setAnnSuccess] = useState("");
  const [preshiftAnnouncement, setPreshiftAnnouncement] = useState({
    announcement_type: "preshift",
    announcement_title: "",
    files: [],
    announcement_groups: [],
    announcement_sections: [
      { section_name: "Today's Note", value: "" },
      { section_name: "Features/Specials", value: "" },
      { section_name: "New Products", value: "" },
      { section_name: "86'd Products", value: "" },
      { section_name: "Guest Count/Reservations of Note", value: "" },
      { section_name: "Section Assignment", value: "" },
      { section_name: "Incentive Program/Active Promotions", value: "" },
      { section_name: "Upsell Suggestions", value: "" },
    ],
    deletedFiles: [],
    addedFiles: [],
  });
  const [announcementToDelete, setAnnouncementToDelete] = useState(null);
  const [currentAnnouncement, setCurrentAnnouncement] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [drafts, setDrafts] = useState([]);

  const setSuccessFunc = successMessage => {
    setAnnSuccess(successMessage);

    setTimeout(() => {
      setAnnSuccess("");
    }, 5000);
  };

  const sendAnnouncement = (operator_name, history, isPreShift = false) => {
    const formData = new FormData();
    setIsLoading(true);

    // Check if we're editing an existing draft
    const editingDraftId = localStorage.getItem('editingDraftId');
    const currentAnnouncement = isPreShift ? preshiftAnnouncement : customAnnouncement;
    const draftId = editingDraftId || currentAnnouncement._draftId;

    if (isPreShift) {
      if (preshiftAnnouncement.files) {
        for (let i = 0; i < preshiftAnnouncement.files.length; i++) {
          formData.append("files", preshiftAnnouncement.files[i]);
        }
      }


      formData.append(
        "announcement_type",
        preshiftAnnouncement.announcement_type,
      );
      formData.append(
        "announcement_groups",
        JSON.stringify(preshiftAnnouncement.announcement_groups),
      );
      formData.append("operator_name", operator_name);
      formData.append(
        "announcement_sections",
        JSON.stringify(
          preshiftAnnouncement.announcement_sections.filter(
            el => el.value !== "",
          ),
        ),
      );

      formData.append("announcement_title", preshiftAnnouncement.announcement_title || '');

    } else {
      if (customAnnouncement.files) {
        for (let i = 0; i < customAnnouncement.files.length; i++) {
          formData.append("files", customAnnouncement.files[i]);
        }
      }


      formData.append(
        "announcement_type",
        customAnnouncement.announcement_type,
      );
      formData.append(
        "announcement_title",
        customAnnouncement.announcement_title,
      );
      formData.append(
        "announcement_message",
        customAnnouncement.announcement_message,
      );
      formData.append(
        "announcement_groups",
        JSON.stringify(customAnnouncement.announcement_groups),
      );
      formData.append("operator_name", operator_name);
    }
    formData.append("operatorId", Cookies.get("userId"));

    // If we have a draft ID, update the existing draft, otherwise create new
    if (draftId) {
      formData.append("draftId", draftId);
      formData.append("isDraft", "false"); // Convert draft to published announcement
      
      axios
        .post(
          (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/announcements/publish-draft",
          formData,
          {
            headers: { Authorization: `Bearer ${Cookies.get("token")}` },
          },
        )
        .then(res => {
          const newAnnouncements = [res.data.announcement, ...announcements];
          setAnnouncements(newAnnouncements);
          history.push("/announcements/all");
          setIsLoading(false);
          setSuccessFunc(
            `You've published a ${isPreShift ? "preshift" : "custom"} announcement`,
          );
          
          // Clear draft tracking
          localStorage.removeItem('editingDraftId');
          localStorage.removeItem('customAnnouncementDraft');
          localStorage.removeItem('preshiftAnnouncementDraft');
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    } else {
      // Create new announcement
      axios
        .post(
          (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") +  "/announcements/create-announcement",
          formData,
          {
            headers: { Authorization: `Bearer ${Cookies.get("token")}` },
          },
        )
        .then(res => {
          const newAnnouncements = [res.data.announcement, ...announcements];
          setAnnouncements(newAnnouncements);
          history.push("/announcements/all");
          setIsLoading(false);
          setSuccessFunc(
            `You've sent a ${isPreShift ? "preshift" : "custom"} announcement`,
          );
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    }
  };

  const getAnnouncements = useCallback((lightweight = false) => {
    const endpoint = lightweight 
      ? "/announcements/get-announcements"
      : "/announcements/get-announcements";
      
    axios
      .get(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + endpoint,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        if (lightweight) {
          // For dashboard, we only need the count, so create a minimal array
          const count = res.data.count || res.data.announcements?.length || 0;
          setAnnouncements(new Array(count).fill({}));
        } else {
          setAnnouncements(res.data.announcements.reverse());
        }
      })
      .catch(err => {
        console.error(err);
        // Fallback: if lightweight endpoint doesn't exist, use regular endpoint
        if (lightweight) {
          getAnnouncements(false);
        }
      });
  }, []);
  const saveDraft = (operator_name, isPreShift = false) => {
    const formData = new FormData();
    setIsLoading(true);

    if (isPreShift) {
      if (preshiftAnnouncement.files) {
        for (let i = 0; i < preshiftAnnouncement.files.length; i++) {
          formData.append("files", preshiftAnnouncement.files[i]);
        }
      }

      formData.append(
        "announcement_type",
        preshiftAnnouncement.announcement_type,
      );
      formData.append(
        "announcement_title",
        preshiftAnnouncement.announcement_title || "",
      );
      formData.append(
        "announcement_groups",
        JSON.stringify(preshiftAnnouncement.announcement_groups),
      );
      formData.append(
        "announcement_sections",
        JSON.stringify(
          preshiftAnnouncement.announcement_sections.filter(
            el => el.value !== "",
          ),
        ),
      );
    } else {
      if (customAnnouncement.files) {
        for (let i = 0; i < customAnnouncement.files.length; i++) {
          formData.append("files", customAnnouncement.files[i]);
        }
      }

      formData.append(
        "announcement_type",
        customAnnouncement.announcement_type,
      );
      formData.append(
        "announcement_title",
        customAnnouncement.announcement_title,
      );
      formData.append(
        "announcement_message",
        customAnnouncement.announcement_message,
      );
      formData.append(
        "announcement_groups",
        JSON.stringify(customAnnouncement.announcement_groups),
      );
    }
    formData.append("operatorId", Cookies.get("userId"));

    return axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/announcements/save-draft",
        formData,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        setIsLoading(false);
        setSuccessFunc("Draft saved successfully");
        return res.data.draft;
      })
      .catch(err => {
        setIsLoading(false);
        console.error(err);
        throw err;
      });
  };

  const getDrafts = useCallback(() => {
    axios
      .get(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/announcements/get-drafts",
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        setDrafts(res.data.drafts);
      })
      .catch(err => console.error(err));
  }, []);

  const deleteDraft = useCallback((draftId) => {
    return axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/announcements/delete-draft",
        {
          draftId,
          operatorId: Cookies.get("userId"),
        },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        setSuccessFunc("Draft deleted successfully");
        // Refresh the drafts list
        getDrafts();
        return res.data;
      })
      .catch(err => {
        console.error("Error deleting draft:", err);
        console.error("Error details:", err.response);
        throw err;
      });
  }, [getDrafts]);

  const saveAnnouncement = announcementId => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") +  "/announcements/save-announcement",
        {
          announcementId,
          operatorId: Cookies.get("userId"),
        },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        if (res.data.announcements.length > 0)
          setAnnouncements(res.data.announcements.reverse());
        setSuccessFunc("Your announcement has been saved");
      })
      .catch(err => console.error(err));
  };

  const deleteAnnouncement = () => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") +  "/announcements/delete-announcement",
        {
          announcementToDelete,
          operatorId: Cookies.get("userId"),
        },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        },
      )
      .then(res => {
        // Get the filtered announcements based on current filter
        // const filteredAnnouncements = res.data.announcements.filter(ann =>
        //   currentFilter === "custom"
        //     ? ann.announcement_type === "custom"
        //     : currentFilter === "preshift"
        //     ? ann.announcement_type === "preshift"
        //     : true
        // );

        // // Find the current announcement's position in filtered list
        const currentFilteredIndex = announcements.findIndex(
          (ann, index) => index === currentAnnouncement
        );

        // Get the previous announcement index
        const previousIndex = currentFilteredIndex - 1;
        
        // If no previous announcement exists, go to the first one
        const newIndex = previousIndex >= 0 ? previousIndex : 0;

        // Update announcements and current announcement index
        setAnnouncements(res.data.announcements.reverse());
        setCurrentAnnouncement(newIndex);
        setAnnouncementToDelete(null);
        setSuccessFunc("Your announcement has been deleted");
      })
      .catch(err => console.error(err));
  };

  const editAnnouncement = (history, isPreShift = false) => {
    const formData = new FormData();
    setIsLoading(true);

    if (isPreShift) {
      if (preshiftAnnouncement.addedFiles) {
        for (let i = 0; i < preshiftAnnouncement.addedFiles.length; i++) {
          formData.append("addedFiles", preshiftAnnouncement.addedFiles[i]);
        }
      }

      formData.append("announcement_id", preshiftAnnouncement._id);
      formData.append(
        "announcement_groups",
        JSON.stringify(preshiftAnnouncement.announcement_groups),
      );
      formData.append(
        "deletedFiles",
        JSON.stringify(preshiftAnnouncement.deletedFiles),
      );
      formData.append(
        "announcement_sections",
        JSON.stringify(
          preshiftAnnouncement.announcement_sections.filter(
            el => el.value !== "",
          ),
        ),
      );
    } else {
      if (customAnnouncement.addedFiles) {
        for (let i = 0; i < customAnnouncement.addedFiles.length; i++) {
          formData.append("addedFiles", customAnnouncement.addedFiles[i]);
        }
      }

      formData.append("announcement_id", customAnnouncement._id);
      formData.append(
        "deletedFiles",
        JSON.stringify(customAnnouncement.deletedFiles),
      );
      formData.append(
        "announcement_title",
        customAnnouncement.announcement_title,
      );
      formData.append(
        "announcement_message",
        customAnnouncement.announcement_message,
      );
      formData.append(
        "announcement_groups",
        JSON.stringify(customAnnouncement.announcement_groups),
      );
    }
    formData.append("operatorId", Cookies.get("userId"));

    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") +  "/announcements/edit-announcement",
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            "Content-Type": "multipart/form-data",
          },
        },
      )
      .then(res => {
        setAnnouncements(res.data.announcements.reverse());
        history.push("/announcements/all");
        setSuccessFunc("You've edited an announcement");
        setIsLoading(false);
      })
      .catch(err => console.error(err));
  };

  const editDraft = (history, isPreShift = false) => {
    const formData = new FormData();
    setIsLoading(true);

    // Get the draft ID from localStorage
    const editingDraftId = localStorage.getItem('editingDraftId');
    const currentAnnouncement = isPreShift ? preshiftAnnouncement : customAnnouncement;
    const draftId = editingDraftId || currentAnnouncement._draftId;

    if (!draftId) {
      console.error('No draft ID found for editing');
      setIsLoading(false);
      return;
    }

    if (isPreShift) {
      if (preshiftAnnouncement.files) {
        for (let i = 0; i < preshiftAnnouncement.files.length; i++) {
          formData.append("files", preshiftAnnouncement.files[i]);
        }
      }

      formData.append("announcement_type", preshiftAnnouncement.announcement_type);
      formData.append("announcement_title", preshiftAnnouncement.announcement_title || "");
      formData.append("announcement_groups", JSON.stringify(preshiftAnnouncement.announcement_groups));
      formData.append("announcement_sections", JSON.stringify(
        preshiftAnnouncement.announcement_sections.filter(el => el.value !== "")
      ));
    } else {
      if (customAnnouncement.files) {
        for (let i = 0; i < customAnnouncement.files.length; i++) {
          formData.append("files", customAnnouncement.files[i]);
        }
      }

      formData.append("announcement_type", customAnnouncement.announcement_type);
      formData.append("announcement_title", customAnnouncement.announcement_title);
      formData.append("announcement_message", customAnnouncement.announcement_message);
      formData.append("announcement_groups", JSON.stringify(customAnnouncement.announcement_groups));
    }

    formData.append("draftId", draftId);
    formData.append("isDraft", "true"); // Keep it as a draft
    formData.append("operatorId", Cookies.get("userId"));

    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/announcements/edit-draft",
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        },
      )
      .then(res => {
        history.push("/announcements/drafts");
        setSuccessFunc("Draft updated successfully");
        setIsLoading(false);
        
        // Clear draft tracking
        localStorage.removeItem('editingDraftId');
        localStorage.removeItem('customAnnouncementDraft');
        localStorage.removeItem('preshiftAnnouncementDraft');
      })
      .catch(err => {
        console.error('Error updating draft:', err);
        setIsLoading(false);
      });
  };

  return (
    <AnnouncementsContext.Provider
      value={{
        setAnnouncements,
        announcements,
        customAnnouncement,
        setCustomAnnouncement,
        sendAnnouncement,
        getAnnouncements,
        saveAnnouncement,
        deleteAnnouncement,
        setAnnouncementToDelete,
        announcementToDelete,
        currentAnnouncement,
        setCurrentAnnouncement,
        preshiftAnnouncement,
        setPreshiftAnnouncement,
        editAnnouncement,
        editDraft,
        setAnnSuccess,
        annSuccess,
        isLoading,
        saveDraft,
        getDrafts,
        deleteDraft,
        drafts,
        setDrafts,
      }}>
      {children}
    </AnnouncementsContext.Provider>
  );
};
